export enum InboxRowStatus {
  open = 'open',
  closed = 'closed',
  redacted = 'redacted',
}
